import React from 'react';
import { Box, Heading } from '@chakra-ui/react';
import { useTokens } from '../../../context/TokenProvider';
export const ModalSectionHeading = (props) => {
    const tokens = useTokens();
    return (React.createElement(Box, { borderColor: tokens.BorderMedium600, borderBottomWidth: tokens.BorderWidth01, width: "100%" },
        React.createElement(Heading, { as: "h3", variant: "md-600-lt-5" }, props.children)));
};
